export default function RedirectToMessaging() {
  window.location.href = '/messages'
  return null
}
